// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"cycOB","footerEnterButton":"q71zY","iconSuccess":"gTP4z","success-icon":"esAal","telegramSign":"SZ7US"};